export class Step2 {
	public intitule = 'stepper.form.simp_at.step2';

	public criteresAttrib = 'form.simp_at.getcriteresattrib';

	constructor() {}
}
